module.exports = __webpack_public_path__ + "img/31.7dcbd6d8.png";